import { supabase } from '../../supabase/client';
import { ApiError } from '@/api/ApiError';
import { ErrorCodes } from 'schemas';

export const getAuthHeaders = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    await supabase.auth.signOut();

    throw new ApiError({
      type: 'error',
      error: 'Authentication required',
      code: ErrorCodes.UNAUTHORIZED,
      message: 'No authentication token available',
    });
  }

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session.access_token}`,
  };
};
